import { render, staticRenderFns } from "./RecordingsDoneView.vue?vue&type=template&id=3abd6a72&scoped=true&"
import script from "./RecordingsDoneView.vue?vue&type=script&lang=ts&"
export * from "./RecordingsDoneView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abd6a72",
  null
  
)

export default component.exports